
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/returns-online/confirmation",
      function () {
        return require("private-next-pages/returns-online/confirmation/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/returns-online/confirmation"])
      });
    }
  